import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const CirklonPlayhead = ({track, currentStep=0}) => { 
    let len = Math.min(track.pattern.length(), 32);
    let ratio = (currentStep % len) / len;
    let style = {
        left: (5 + ratio * 530) + 'px'
    };
    return (
        <div style={style} className="cirklon-playhead">
        </div>);
};

const mapStateToProps = (state, props) => {
    let resolution = state.sequencer.displayResolution;
    let trackStep = props.track.sequencerEngine.trackStep;
    return {
      currentStep: props.track.getPatternStep(trackStep)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CirklonPlayhead);
